import ReportWrapper from './ReportWrapper.vue'

export default ReportWrapper
